// ./TourismList.tsx

import React from 'react';
import { Container } from './styles';
import IExperience from 'interfaces/IExperience';

interface Props {
  experiences?: IExperience[];
  selectedExperience: string | null;
  onExperienceSelect: (experienceTitle: string) => void;
}

const TourismList = (props: Props): JSX.Element => {
  const { experiences, selectedExperience, onExperienceSelect } = props;

  return (
    <Container>
      <ul>
        {experiences?.slice(0, 12).map(experience => {
          const isSelected = experience.title === selectedExperience;
          return (
            <li
              key={experience.id}
              onClick={() => onExperienceSelect(experience.title)}
              className={isSelected ? 'selected' : ''}>
              <img src={experience.image} alt={experience.title} />
              <span>{experience.title}</span>
            </li>
          );
        })}
      </ul>
    </Container>
  );
};

export default TourismList;
